import { api } from "@/lib/api";

export const suppliersApi = {
  list: (params) => api.get("/suppliers", { params }).then((r) => r.data),
  get: (id) => api.get(`/suppliers/${id}`).then((r) => r.data),
  create: (body) => api.post("/suppliers", body).then((r) => r.data),
  update: (id, body) => api.put(`/suppliers/${id}`, body).then((r) => r.data),
};
